module.exports = __webpack_public_path__ + "world.png?3fb1d0ccf1e7579e19e07d538e7e4627";


//////////////////
// WEBPACK FOOTER
// ./src/assets/world.png
// module id = 1030
// module chunks = 0